import { render, staticRenderFns } from "./report-jiben.vue?vue&type=template&id=2c62e66f&scoped=true&"
import script from "./report-jiben.vue?vue&type=script&lang=ts&"
export * from "./report-jiben.vue?vue&type=script&lang=ts&"
import style0 from "./report-jiben.vue?vue&type=style&index=0&id=2c62e66f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62e66f",
  null
  
)

export default component.exports